module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: [{
      'disabled': _vm.disabled,
      'loading': _vm.isLoading
    }, _vm.buttonClasses],
    attrs: {
      "disabled": _vm.disabled || _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.$emit('click', $event)
      }
    }
  }, [(_vm.isLoading) ? _c('yz-spinner', {
    attrs: {
      "size": _vm.spinnerSize,
      "is-loading": true
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _vm._t("default") : _vm._e(), _vm._v("\n  " + _vm._s(_vm.text) + "\n")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c545c614","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/LoadingButton.vue
// module id = 547
// module chunks = 2